import { BridgeComponent } from "@hotwired/hotwire-native-bridge";

export default class extends BridgeComponent {
  static component = "switch-subdomain";

  switchSubdomain(e) {
    e.preventDefault();

    this.send("switchSubdomain", { subdomain: this.subdomain }, () => {
      // no-op, navigation would have occured by now.
    })
  }

  connect() {
    this.subdomain = this.element.dataset["bridgeSubdomain"];

    this.element.addEventListener("click", this.switchSubdomain.bind(this));
  }
}